var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinevectorbottom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 865,
    height: 328,
    viewBox: "0 0 865 328",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M855 318C834.833 253.333 758 110.5 571 180C185.168 323.397 5 145.5 1.5 1",
    stroke: "url(#paint0_linear_10001_3808)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M857.023 325.448L847 320.2L862.271 315.425L857.023 325.448Z",
    fill: "url(#paint1_linear_10001_3808)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10001_3808",
    x1: 428.25,
    y1: 318,
    x2: 428.25,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BDA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A4BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10001_3808",
    x1: 854.635,
    y1: 317.812,
    x2: 857.023,
    y2: 325.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BDA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A4BC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinevectorbottom);
export default __webpack_public_path__ + "static/media/linevectorbottom.9ce4e1919cc11a8ddb962cd7709bedc1.svg";
export { ForwardRef as ReactComponent };